/* Black Friday 2026 : onglets et flèches de la sélection, compte à rebours. Chargé seulement si settings.bf_enable est vrai. */
(function () {
  function initTabs(root) {
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      /* Hauteur verrouillée au plus grand panneau vu : la page ne saute pas au changement d'onglet */
      root.style.minHeight = Math.max(parseFloat(root.style.minHeight) || 0, root.offsetHeight) + "px";
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'center' });
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) refreshArrows(panel);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var d = e.key === 'ArrowRight' ? 1 : -1;
          select(tabs[(i + d + tabs.length) % tabs.length], true);
        }
      });
    });
  }

  function refreshArrows(panel) {
    var rail = panel.querySelector('.mv-bf-sel__rail');
    var prev = panel.querySelector('.mv-bf-sel__arrow--prev');
    var next = panel.querySelector('.mv-bf-sel__arrow--next');
    if (!rail || !prev || !next) return;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  }

  function initRails(root) {
    [].forEach.call(root.querySelectorAll('.mv-bf-sel__panel'), function (panel) {
      var rail = panel.querySelector('.mv-bf-sel__rail');
      if (!rail) return;
      [].forEach.call(panel.querySelectorAll('.mv-bf-sel__arrow'), function (btn) {
        btn.addEventListener('click', function () {
          var d = btn.classList.contains('mv-bf-sel__arrow--next') ? 1 : -1;
          var item = rail.querySelector('.mv-bf-sel__item');
          var step = item ? item.getBoundingClientRect().width + 16 : rail.clientWidth;
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollBy({ left: d * step, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      rail.addEventListener('scroll', function () { refreshArrows(panel); }, { passive: true });
      refreshArrows(panel);
    });
  }

  /* Compte à rebours : visible seulement les 7 derniers jours avant bf_end, et jamais après. */
  function countdown() {
    [].forEach.call(document.querySelectorAll('[data-mv-bf-end]'), function (el) {
      var end = Date.parse(el.getAttribute('data-mv-bf-end'));
      if (isNaN(end)) return;
      var WEEK = 7 * 864e5;
      function tick() {
        var left = end - Date.now();
        if (left <= 0 || left > WEEK) { el.hidden = true; return false; }
        el.hidden = false;
        var s = Math.floor(left / 1000);
        var vals = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(vals).forEach(function (k) {
          var c = el.querySelector('[data-u="' + k + '"]');
          if (c) c.textContent = vals[k] < 10 ? '0' + vals[k] : vals[k];
        });
        return true;
      }
      if (el._mvBfTimer) clearInterval(el._mvBfTimer);
      if (tick()) el._mvBfTimer = setInterval(function () { if (!tick()) clearInterval(el._mvBfTimer); }, 1000);
    });
  }
  window.mvBfCountdown = countdown;

  /* Bouton Copier du code : presse-papiers, repli execCommand, retour visuel 2 s */
  function copyCode(btn) {
    var code = btn.getAttribute('data-mv-bf-copy');
    var label = btn.querySelector('[data-mv-bf-copy-label]');
    function done() {
      var was = label.textContent;
      btn.classList.add('is-copied');
      label.textContent = 'Copié ✓';
      setTimeout(function () { btn.classList.remove('is-copied'); label.textContent = was === 'Copié ✓' ? 'Copier' : was; }, 2000);
    }
    function legacy() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, legacy);
    else legacy();
  }

  function init() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-mv-bf-copy]');
      if (b) copyCode(b);
    });
    [].forEach.call(document.querySelectorAll('[data-mv-bf-tabs]'), function (root) {
      initTabs(root);
      initRails(root);
    });
    countdown();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
